<template>
  <v-container id="main">
  </v-container>
</template>

<script>
  export default {
    name: 'Home',
  }
</script>
<style>
  #main{
    height: 100%;
    width: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url("../assets/fondoivt.png");
    /* background-image: url("../assets/fondoivttest.png");*/
 }

 .container {
    max-width: unset !important;
  }
</style>
